import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Box, Container, Typography, Skeleton, Stack } from "@mui/material";
import { getTermsCondition } from "../../services/TermsConditionService";

const extractBody = (html) => {
  const match = html?.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
  return match ? match[1] : html;
};

const TermsCondition = () => {
  const { data: htmlContent, isLoading } = useQuery({
    queryKey: ["termsCondition"],
    queryFn: getTermsCondition,
  });

  if (isLoading) {
    return (
      <Container sx={{ py: { xs: 4, md: 6 } }}>
        <Skeleton variant="text" height={50} width="50%" />
        <Stack spacing={2} mt={3}>
          {[...Array(8)].map((_, i) => (
            <Skeleton key={i} variant="text" height={24} width={`${80 + (i % 3) * 7}%`} />
          ))}
        </Stack>
      </Container>
    );
  }

  if (!htmlContent) {
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <Typography>No terms and conditions data found.</Typography>
      </Box>
    );
  }

  return (
    <Container sx={{ py: { xs: 4, md: 6 } }}>
      <Box dangerouslySetInnerHTML={{ __html: extractBody(htmlContent) }} />
    </Container>
  );
};

export default TermsCondition;
